$(document).on(
  "taydu2_cuuthienhuyennu_thatim rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    if ($("#blockFeatureSwiper").length > 0) {
      $("#blockFeatureSwiper").initSwiper({
        swiperOptions: {
          slidesPerView: 1,
          centeredSlides: true,
          effect: "fade",
          spaceBetween: 0,
          lazy: {
            loadPrevNext: true,
          },
          navigation: {
            nextEl: ".swiper-button-next--featureSwiper",
            prevEl: ".swiper-button-prev--featureSwiper",
          },
        },
      });
    }

    const $levelList = $(".feature_list .feature_slide").map(function () {
      return {
        level: $(this).data("level"),
        exp: $(this).data("exp"),
      };
    });
    const $level = $(".levelup__number");
    const $exp = $(".group__level--exp span");
    const $levelBar = $(".group__level--progress-bar-fill span");
    const $featureList = $(".feature_list .feature_slide");
    const getLevel = (point) => {
      let level = 0;
      let exp = 0;
      if (point < $levelList[0].exp) {
        level = 0;
        exp = $levelList[0].exp;
      } else if (point >= $levelList[$levelList.length - 1].exp) {
        level = $levelList[$levelList.length - 1].level;
        exp = $levelList[$levelList.length - 1].exp;
      } else {
        for (let i = 1; i < $levelList.length; i++) {
          if (point < $levelList[i].exp) {
            level = $levelList[i - 1].level;
            exp = $levelList[i].exp;
            break;
          }
        }
      }
      return { level, point, exp };
    };
    const getLevelBar = (point) => {
      let resultMilestone = 0;
      let startMilestone = 0;
      let endMilestone = $levelList[0].exp;
      for (let i = 0; i < $levelList.length; i++) {
        if (point < $levelList[i].exp) {
          startMilestone = i === 0 ? 0 : $levelList[i - 1].exp;
          endMilestone = $levelList[i].exp;
          resultMilestone =
            ((point - startMilestone) / (endMilestone - startMilestone)) * 100;
          break;
        }
        if (point >= $levelList[$levelList.length - 1].exp) {
          resultMilestone = 100;
          break;
        }
      }
      return resultMilestone;
    };
    const getFeature = (level, point) => {
      if (level >= 0 && point > 0) {
        $featureList.each(function () {
          if ($(this).index() <= level) {
            // console.log($(this).index(), level);
            $(this).addClass("levelup");
          }
        });
      }
    };
    function updateLevelUI(pointLevel) {
      const { level, point, exp } = getLevel(pointLevel);
      $level.text(level);
      $exp.text(`${point}/${exp}`);
      const levelBar = getLevelBar(point);
      $levelBar.css("width", `${levelBar}%`);
      $featureList.removeClass("levelup");
      getFeature(level, point);
      // Slide chưa mở hiển thị pet xám qua CSS filter:grayscale (thatim.scss), bật màu lại khi có .levelup —
      // không đổi src ảnh (không cần bản -lock riêng cho từng pet).
      if ($("#blockFeatureSwiper").length > 0) {
        var swiperInstance = $("#blockFeatureSwiper")[0].swiper;
        if (swiperInstance) {
          swiperInstance.slideTo(level, 0);
        }
      }
    }
    updateLevelUI(pointLevel);
    window.updateLevelUI = updateLevelUI;
  }
);
